import { generatePdf } from "../api";
import { toast } from "./Toast";
import "./ResponseModal.css";
import { useState } from "react";

export default function ResponseModal({ emailId, type, defaultText = "", onClose, onSend, isSuperuser }) {
  const [body, setBody] = useState(defaultText || "");
  const [isDownloading, setIsDownloading] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [attachPdf, setAttachPdf] = useState(false);

  async function handleSendAction(actionType) {
    setIsSending(true);
    try {
      await onSend(body, actionType, attachPdf);
      if (actionType === "send_for_approval") setSubmitted(true);
    } catch (err) {
      toast(err.message, "error");
    } finally {
      setIsSending(false);
    }
  }

  async function handleDownloadPdf() {
    setIsDownloading(true);
    try {
      const pdf = await generatePdf(emailId, body);
      const url = window.URL.createObjectURL(pdf);
      const link = document.createElement("a");
      link.href = url;
      link.download = `reply-${emailId}.pdf`;
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      toast("PDF გენერაცია ვერ მოხერხდა", "error");
    } finally {
      setIsDownloading(false);
    }
  }

  return (
    <div className="respmodal-overlay">
      <div className="respmodal-box">
        <h2 className="respmodal-title">
          {type === "reply" ? "AI გენერირებული პასუხი" : "ხელით წერა"}
        </h2>

        <textarea
          className="respmodal-textarea"
          value={body}
          onChange={(e) => setBody(e.target.value)}
        />

        <div className="respmodal-options">
          <label className="pdf-attach-label">
            <input
              type="checkbox"
              checked={attachPdf}
              onChange={(e) => setAttachPdf(e.target.checked)}
            />
            PDF-ის დართვა გაგზავნისას
          </label>
        </div>

        <div className="respmodal-footer">
          <button
            className="resp-btn pdf"
            onClick={handleDownloadPdf}
            disabled={!body.trim() || isDownloading || isSending}
          >
            {isDownloading ? "იტვირთება..." : "PDF ჩამოტვირთვა"}
          </button>

          <div className="right-btns">
            <button className="resp-btn cancel" onClick={onClose}>
              გაუქმება
            </button>

            {!isSuperuser && (
              <button
                className={`resp-btn approve ${submitted ? "approved" : ""}`}
                disabled={!body.trim() || isSending || isDownloading}
                onClick={() => handleSendAction("send_for_approval")}
              >
                {submitted ? "გაგზავნილია დასამტკიცებლად" : isSending ? "იგზავნება..." : "დასამტკიცებლად გაგზავნა"}
              </button>
            )}

            <button
              className="resp-btn send"
              disabled={!body.trim() || isSending || isDownloading}
              onClick={() => handleSendAction("send_directly")}
            >
              {isSending ? "იგზავნება..." : "პირდაპირ გაგზავნა"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
